import { memo } from "react";
import { useHistory } from "react-router-dom";
import {
  Button,
  Grid,
  Theme,
  Typography,
  useMediaQuery,
} from "@mui/material";

import ThumbsUp from "assets/images/icons/thumbs-up.svg";
import { HeroText } from "components/shared/Typography";
import useDialog from "hooks/useDialog";

const RegisterSuccessForm = () => {
  const history = useHistory();
  const { openRegisterSuccessDialog, setOpenRegisterSuccessDialog } =
    useDialog();
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('sm')
  );

  return (
    <Grid container justifyContent="center">
      <Grid
        item
        container
        direction="column"
        alignItems="center"
        spacing={3}
        {...(openRegisterSuccessDialog
          ? { xs: 12 }
          : { lg: 6, md: 7, sm: 10, xs: 12 })}
      >
        <Grid item>
          <HeroText align="center">
            Thank you for your interest!
          </HeroText>
        </Grid>
        <Grid item>
          <img width={80} height={80} src={ThumbsUp} alt="Thumb Up" />
        </Grid>
        <Grid item>
          <Typography variant="body1" align="center">
            We will review your account request. Please check your email for an
            account approval or information updates.
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1" align="center">
            In the meantime, you are welcome to browse the catalog and the
            homepage at your convenience.
          </Typography>
        </Grid>
        <Grid
          item
          container
          direction={isMobile ? "column" : "row"}
          spacing={2}
          justifyContent="center"
        >
          <Grid item>
            <Button
              size="large"
              onClick={() => {
                setOpenRegisterSuccessDialog(false);
                history.push("/");
              }}
              fullWidth={isMobile}
            >
              Return home
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="outlined"
              size="large"
              onClick={() => {
                setOpenRegisterSuccessDialog(false);
                history.push("/catalog");
              }}
              fullWidth={isMobile}
            >
              Browse catalog
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default memo(RegisterSuccessForm);
